"use strict";

exports.__esModule = true;
exports.createMetricFieldScale = createMetricFieldScale;
var _scales = require("../../Charts/scales");
var _Catalogs = require("../../../Catalogs");
/**
 * Create the appropriate d3 scale for the given metric field name.
 */
function createMetricFieldScale(from, to, fieldName, data) {
  if (fieldName === "timestamp") {
    return (0, _scales.createTimeScale)(from, to, Array.from(new Set(data)).sort());
  }
  if (isMetricFieldName(fieldName)) {
    return (0, _scales.createBandScale)(from, to, Array.from(new Set(data)));
  }
  return (0, _scales.createLinearScale)(from, to, data);
}
function isMetricFieldName(input) {
  for (var i = 0; i < _Catalogs.metricFieldDefinitions.length; i++) {
    if (_Catalogs.metricFieldDefinitions[i].name === input) {
      return true;
    }
  }
  return false;
}